module.exports = __webpack_public_path__ + "img/it.48651b91.svg";